/**
 * Variant Image Filter for Shopify Dawn 11+
 * Uses CSS order property to visually reorder gallery without touching Dawn's DOM.
 *
 * IMAGE NAMING CONVENTION (all lowercase, spaces as underscores):
 *   sandstone-1.jpg, sandstone-2.jpg, sandstone-3.jpg
 *   harvest-1.jpg,   harvest-2.jpg,   harvest-3.jpg
 *   maroon-1.jpg,    maroon-2.jpg,    maroon-3.jpg
 *   powder_blue-1.jpg, powder_blue-2.jpg, powder_blue-3.jpg
 */

(function () {
  'use strict';

  var lastVariantId = null;
  var allColours = [];

  // Inject flex order styles once
  var styleEl = document.createElement('style');
  styleEl.id = 'variant-image-filter-styles';
  document.head.appendChild(styleEl);

  function getVariants() {
    try { return window.ShopifyAnalytics.meta.product.variants || []; }
    catch(e) { return []; }
  }

  function getVariantById(variantId) {
    var id = parseInt(variantId, 10);
    var variants = getVariants();
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) return variants[i];
    }
    return null;
  }

  function getColour(variant) {
    if (!variant) return null;
    var title = variant.public_title || variant.title || variant.name || variant.option1 || '';
    return title.split('/')[0].trim().toLowerCase().replace(/\s+/g, '_');
  }

  function buildColourList() {
    var variants = getVariants();
    allColours = [];
    for (var i = 0; i < variants.length; i++) {
      var c = getColour(variants[i]);
      if (c && allColours.indexOf(c) === -1) allColours.push(c);
    }
  }

  function getFilename(img) {
    var src = img.getAttribute('src') || img.getAttribute('data-src') || '';
    var raw = src.split('/').pop().split('?')[0];
    return raw.replace(/_\d+x\d*[a-z]*\./i, '.').toLowerCase();
  }

  function filenameMatchesAnyColour(filename) {
    for (var i = 0; i < allColours.length; i++) {
      if (filename.indexOf(allColours[i]) !== -1) return true;
    }
    return false;
  }

  function applyColour(colour) {
    // Make the lists flex so order property works
    var css = '.product__media-list, .thumbnail-list { display: flex !important; flex-wrap: nowrap; }\n';

    // Assign CSS order to each main gallery item
    var mainItems = document.querySelectorAll('.product__media-list .product__media-item');
    mainItems.forEach(function (item, i) {
      var img = item.querySelector('img');
      var order;
      if (!img) {
        order = 50; // shared non-image
      } else {
        var filename = getFilename(img);
        if (filename.indexOf(colour) !== -1) {
          order = 1; // selected colour → front
        } else if (!filenameMatchesAnyColour(filename)) {
          order = 50; // lifestyle/shared → middle
        } else {
          order = 100; // other colours → end
        }
      }
      // Use a data attribute to scope the CSS rule
      item.setAttribute('data-vif-index', i);
      css += '.product__media-list .product__media-item[data-vif-index="' + i + '"] { order: ' + order + '; }\n';
    });

    // Same for thumbnails
    var thumbItems = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
    thumbItems.forEach(function (item, i) {
      var img = item.querySelector('img');
      var order;
      if (!img) {
        order = 50;
      } else {
        var filename = getFilename(img);
        if (filename.indexOf(colour) !== -1) {
          order = 1;
        } else if (!filenameMatchesAnyColour(filename)) {
          order = 50;
        } else {
          order = 100;
        }
      }
      item.setAttribute('data-vif-thumb-index', i);
      css += '.thumbnail-list .thumbnail-list__item[data-vif-thumb-index="' + i + '"] { order: ' + order + '; }\n';
    });

    styleEl.textContent = css;

    // Scroll both lists back to start so first item is visible
    setTimeout(function () {
      var mainList = document.querySelector('.product__media-list');
      var thumbList = document.querySelector('.thumbnail-list');
      if (mainList) mainList.scrollLeft = 0;
      if (thumbList) { thumbList.scrollLeft = 0; thumbList.scrollTop = 0; }

      // Click the first visible thumbnail to update main viewer
      var firstThumb = document.querySelector('.thumbnail-list .thumbnail-list__item[data-vif-thumb-index]');
      // Find the one with order:1
      var allThumbs = document.querySelectorAll('.thumbnail-list .thumbnail-list__item');
      var firstVisible = null;
      allThumbs.forEach(function(t) {
        var img = t.querySelector('img');
        if (!img) return;
        var filename = getFilename(img);
        if (!firstVisible && filename.indexOf(colour) !== -1) firstVisible = t;
      });

      if (firstVisible) {
        var btn = firstVisible.querySelector('button');
        if (btn) btn.click();
      }
    }, 60);
  }

  function checkVariantChange() {
    var input = document.querySelector('input[name="id"]');
    if (!input || !input.value) return;
    var currentId = input.value;
    if (currentId === lastVariantId) return;
    lastVariantId = currentId;

    if (!allColours.length) buildColourList();

    var variant = getVariantById(currentId);
    var colour  = getColour(variant);
    if (colour) applyColour(colour);
  }

  function start() {
    buildColourList();
    checkVariantChange();
    setInterval(checkVariantChange, 100);

    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') checkVariantChange();
    });

    var variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      variantSelects.addEventListener('change', function () {
        setTimeout(checkVariantChange, 50);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

})();